export default "__VITE_ASSET__YFY$mOGn__"